/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Nav_ResearchInputs */

const en_landing_preview_nav_research = /** @type {(inputs: Landing_Preview_Nav_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research`)
};

/**
* | output |
* | --- |
* | "Research" |
*
* @param {Landing_Preview_Nav_ResearchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_nav_research = /** @type {((inputs?: Landing_Preview_Nav_ResearchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Nav_ResearchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_nav_research(inputs)
});